import flow from 'lodash/flow'

const fixMissingPlanName = (profile) => {
  if (!profile.planName) {
    return {
      ...profile,
      planName: 'MY PLAN'
    }
  }
  return profile
}

export default flow([
  profile => fixMissingPlanName(profile)
])





// WEBPACK FOOTER //
// ./src/utils/makeProfileCompatible.js